import { formatMoney } from "../utils/format";
export default function BillingConditionsDetails({ terms, mentions }) {
  if (!terms) return null;
  return <div className="space-y-1 text-sm text-gray-700">
    <p>Devise : <strong>{terms.devise}</strong> · Tarif horaire : <strong>{formatMoney(terms.taux_horaire, terms.devise)} / heure</strong></p>
    <p>{mentions?.delai || `Paiement à ${terms.delai_paiement} jours après émission de chaque facture.`}</p>
    <p>{mentions?.tva ?? terms.mention_tva}</p>
    <p>{mentions?.penalites || "Aucune pénalité française B2B activée."}</p>
    {mentions?.indemnite && <p>{mentions.indemnite}</p>}
  </div>;
}
